import { render, staticRenderFns } from "./ModalPaymentCategoriesAdd.vue?vue&type=template&id=95ef8a3c"
import script from "./ModalPaymentCategoriesAdd.vue?vue&type=script&lang=js"
export * from "./ModalPaymentCategoriesAdd.vue?vue&type=script&lang=js"
import style0 from "./ModalPaymentCategoriesAdd.vue?vue&type=style&index=0&id=95ef8a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports